export default __webpack_public_path__ + "static/media/sidebar_salesorder_gray.63930d68.svg";